import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ListItemIcon, ListItemText } from '@mui/material';
import { useController } from 'react-hook-form';
import { MenuItem, NotSelectedMenuItem } from '../Menu';
import { ChipContainer, sxAvatar, sxListItemIcon, sxListItemText, sxMenuItem, sxSelectMultiple, sxSelectWithIcon, } from './CustomSelect.styled';
import { Avatar } from '../Avatar';
import { Chip } from '../Chip';
import { Select } from '../Select';
import { Skeleton } from '../Skeleton';
/**
 * Construct Select by data, provided whether with {@link items} or {@link getQuery} property,
 * and uses {@link keyProperty} as key property name, {@link valueProperty} as value property name
 * and {@link iconProperty} as icon property name,
 *
 * @param multiple optional
 * @param items required
 * @param getQuery required
 * @param keyProperty required
 * @param valueProperty required
 * @param iconProperty optional
 * @param withEmptyValue optional
 * @returns
 */
const CustomSelect = ({ multiple, keyProperty, valueProperty, iconProperty, items, withEmptyValue, getQuery, ...controllerProps }) => {
    const { field } = useController(controllerProps);
    // const queryResult = getQuery?.({}); with search variant
    const queryResult = getQuery?.();
    const options = queryResult?.data ?? items;
    if (!options)
        return _jsx(Skeleton, { variant: "rounded", width: "100%", height: 36 });
    return (_jsxs(Select, { ...field, multiple: multiple, 
        // TODO: to delete later this ts-expect comment @ts-expect-error Mui type bug: 'selected' is unknown instead of
        // proper infer.
        renderValue: multiple
            ? (selected) => (_jsx(ChipContainer, { children: selected.map((value) => (_jsx(Chip, { variant: "outlined", size: "small", color: "primary", label: options.find((item) => item[keyProperty] === value)?.[valueProperty] }, value))) }))
            : undefined, sx: multiple ? sxSelectMultiple : iconProperty ? sxSelectWithIcon : {}, children: [withEmptyValue && (
            // TODO: should also be used with `value={null}` probably, value here is a key/value pair.
            // Currently, yup `transform(emptyToNull)` is used in Customer and Supplier schemas.
            _jsx(NotSelectedMenuItem, { value: "" })), options.map((item) => (_jsx(MenuItem, { value: item[keyProperty], sx: sxMenuItem, children: iconProperty ? (_jsxs(_Fragment, { children: [_jsx(ListItemIcon, { sx: sxListItemIcon, children: _jsx(Avatar, { alt: item[valueProperty], image: item[iconProperty], sx: sxAvatar }) }), _jsx(ListItemText, { primary: item[valueProperty], sx: sxListItemText })] })) : item[valueProperty] }, item[keyProperty])))] }));
};
export { CustomSelect };
